import * as React from 'react';
import ManageHelpDocument from './manage-help-document';
import useHelpDocumentManagement from '../../../hooks/useHelpDocumentManagement';
import HelpDocumentManagement from '../../../models/helpDocumentManagement';
import { useParams } from 'react-router';

const EditGlobalDocument = () => {
  const defaultDocument = {
    feature: '',
    title: '',
    content: '',
    alternative: '',
    snippetId: -1,
    snippetGroupId: 0,
    revision: 0,
    clientId: -1,
    tags: [],
    dashboards: []
  } as HelpDocumentManagement;
  const { clientId, snippetId } = useParams();

  const [loading, setLoading] = React.useState<boolean>(true);
  const [document, setDocument] = React.useState<HelpDocumentManagement>(defaultDocument);
  const { fetchGlobalDocument, fetchGlobalDocumentFromClient } = useHelpDocumentManagement();

  React.useEffect(() => {
    if (!loading) {
      setLoading(true);
    }
    if (clientId) {
      fetchGlobalDocumentFromClient(Number(clientId), Number(snippetId))
        .then(document => {
          setLoading(false);
          setDocument(document);
        })
        .catch(err => {
          console.log(err.responseJSON.message);
        });
    } else {
      fetchGlobalDocument(Number(snippetId))
        .then(document => {
          setLoading(false);
          setDocument(document);
        })
        .catch(err => {
          console.log(err.responseJSON.message);
        });
    }
  }, []);

  return <ManageHelpDocument document={document} loading={loading} isGlobal />;
};

export default EditGlobalDocument;
